import { MaytechService } from '../../_maytech/maytech.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpUtilsService, QueryParamsModel, BaseModel, QueryResultsModel } from '../../../core/_base/crud';
import { MaytechTenantService } from '../../_maytech/maytech.tenant.service';
import { ActivatedRoute } from '@angular/router';
import { AppState } from '../../_reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';


// Real REST API
@Injectable()
export class BookingCustomerService extends MaytechService {
    constructor(http: HttpClient,
        httpUtils: HttpUtilsService,
        route: ActivatedRoute,
        public store: Store<AppState>,
        tenantService: MaytechTenantService) {

        super(http, httpUtils, route, store, tenantService);

        if (tenantService.currentClient != null)
            this.API_URL = tenantService.currentClient.apiurl + '/bookingcustomer';

    }

    updateBookingCustomerBookingFields(bookingID: number, bookingProductSessionID: number, objs: any[] = []): Observable<any> {
        const url = this.API_URL + "/UpdateBookingCustomerBookingFields/" + bookingID.toString() + "/" + bookingProductSessionID.toString();
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<any>(url, { objs: objs }, { headers: httpHeaders });
    }
}
